export default "__VITE_ASSET__BipsYn4M__"